export default {
  'PerformerBannerSearch.inputATitle': { en: 'Keywords', fr: 'Mots clés' },
  'PerformerBannerSearch.location': { en: 'Location', fr: 'Emplacement' },
};
